import React from 'react';
import PropTypes from 'prop-types';
import { useSpring, animated } from '@react-spring/web';
import { ReactSVG } from 'react-svg';
import { Textfit } from 'react-textfit';
import bricks from '../../assets/backgrounds/bricks.svg';
import '../Slides.scss'
import './UpcomingConcertSlide.scss';

const UpcomingConcertSlide = ({ data }) => {
  const {
    kid_name,
    nextConcertName,
    band_name
  } = data;

  const kidNameSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    delay: 200,
  });

  const headingSpring = useSpring({
    from: { opacity: 0, transform: 'translateX(100px)' },
    to: { opacity: 1, transform: 'translateX(0px)' },
    delay: 400,
    config: {
      tension: 180,  // lower tension = more wobble
      friction: 12,  // lower friction = 'less damping'
    },
  });

  const posterSpring = useSpring({
    from: { opacity: 0.5, transform: 'scale(0)' },
    to: { opacity: 1, transform: 'scale(1)' },
    delay: 600,
    config: {
      tension: 180,
      friction: 12,
    },
    });
  

  const headingText = nextConcertName ? 'Next Concert' : 'Concert is Soon';
  const concertText = nextConcertName ||  'Rocksteady';

  return (
    <div className='Slide__concert_upcoming'>
      <animated.h2 className='Slide__concert_upcoming__kidName' style={kidNameSpring}>
        <Textfit className='Slide__concert_upcoming__kidName__text' max={32} mode="single" style={{ maxWidth: '247px' }}>
          {kid_name}
          ’s
        </Textfit> 
      </animated.h2>
      <animated.h2 className='Slide__concert_upcoming__heading' style={headingSpring}>{headingText}</animated.h2>
      <animated.div className='Slide__concert_upcoming__poster' style={posterSpring}>
        <div className="Slide__concert_upcoming__banner__bandName">
          <div className="Slide__concert_upcoming__banner__bandName__scrollingText">
            <span>{`${(band_name || 'coming soon')} / `.repeat(10)}</span>
            <span aria-hidden="true">{`${(band_name || 'coming soon')} / `.repeat(10)}</span>
          </div>
        </div>
        <div className="Slide__concert_upcoming__banner__comingSoon">
          <div className="Slide__concert_upcoming__banner__comingSoon__scrollingText">
            <span>{`coming soon / `.repeat(20)}</span>
            <span aria-hidden="true">{`coming soon / `.repeat(20)}</span>
          </div>
        </div>
        <div className={nextConcertName ? 'Slide__concert_upcoming__concertText' : 'Slide__concert_upcoming__fallbackConcertText'}>
          <animated.h1>{concertText}</animated.h1>
          <animated.h2>Concert</animated.h2>
        </div>     
      </animated.div>
      <animated.div className='Slide__concert_upcoming__background'>
        <ReactSVG src={bricks} />
      </animated.div>
    </div>
  )
}

export default UpcomingConcertSlide;

const DataProps = {
  band_name: PropTypes.string,
  nextConcertName: PropTypes.string,
  kid_name: PropTypes.string.isRequired
}

UpcomingConcertSlide.propTypes = {
  data: PropTypes.shape(DataProps).isRequired
}